import moment from "moment-timezone";

export const confirmAdminDiscuss = (detailDiscussData: any) => {
    return (
        detailDiscussData &&
        moment.tz(detailDiscussData?.issue_at, "Asia/Seoul").isAfter(moment().tz("Asia/Seoul"))
    );
};